import { Mail, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const APP_URL = 'https://console.filemingle.com';

export default function Footer() {
  const year = new Date().getFullYear();

  const toolLinks = [
    { label: 'PDF Form Builder', to: '/pdf-form-builder' },
    { label: 'Fillable PDF Builder', to: '/fillable-pdf-builder' },
    { label: 'Image to PNG', to: '/image-to-png' },
    { label: 'JPG to PNG', to: '/jpg-to-png' },
    { label: 'Compress Image', to: '/compress-image' },
    { label: 'PNG Compressor', to: '/png-compressor' },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Use', href: '#' },
  ];

  return (
    <footer className="bg-slate-950 text-slate-400">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-16 pb-8">
        {/* Top grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4 group">
              <img
                src="/assets/logo_small.png"
                alt="FileMingle"
                className="h-8 w-8 object-contain"
              />
              <span className="text-white font-bold text-lg tracking-tight">
                FileMingle
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-slate-500 max-w-xs mb-6">
              An all-in-one file utility platform for creating fillable PDFs,
              converting images, compressing files, and managing documents —
              directly from your browser.
            </p>
            <a
              href={APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-brand-gradient text-white text-sm font-semibold hover:opacity-90 hover:scale-105 transition-all duration-200 shadow-lg shadow-brand-blue/20"
            >
              <ExternalLink size={14} aria-hidden="true" />
              Launch App
            </a>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-wide">
              Tools
            </h4>
            <ul className="space-y-2.5">
              {toolLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-slate-500 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 tracking-wide">
              Legal
            </h4>
            <ul className="space-y-2.5 mb-7">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-500 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="text-white font-semibold text-sm mb-3 tracking-wide">
              Contact
            </h4>
            <a
              href="mailto:devroldy@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-white transition-colors duration-200"
            >
              <Mail size={14} aria-hidden="true" />
              devroldy@gmail.com
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            © {year} FileMingle. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            {legalLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-xs text-slate-600 hover:text-slate-400 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
